// Copyright (c) Hamilton Manufacturing Corp.
import React, { useContext } from 'react';
import styled from 'styled-components';
import { generateId } from '../api/utility';
import CheckBox from './CheckBox';
import { FormContext } from './Form';
import Radio from './Radio';

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;
const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;
const MinContent = styled.div`
    margin: 0 0.5em;
    font-weight: 500;
`;
export const RadioItem = ({ name, ...props }) => {
    const { values, submitting, editing, setValues, errors, setErrors } = useContext(FormContext);

    const handleChange = (e) => {
        if (errors[name] === 'unTouched') {
            if (errors[name] === false) return;
            setErrors({
                ...errors,
                [name]: false
            })
        }

        setValues({
            ...values,
            [name]: e
        })
    }

    return (
        <label>
            <Row>
                <Radio
                    checked={values[name] === props.value}
                    onChange={() => handleChange(props.value)}
                    disabled={props.disabled || submitting || !editing}
                    {...props}
                />
            </Row>
        </label>
    );
}
export const CheckBoxItem = ({ ...props }) => {
    const { values, submitting, editing, setValues } = useContext(FormContext);

    if (!Array.isArray(values[props.name])) {
        console.error('Checked list item values must be an array.')
        return;
    }

    const handleChange = (checked, e) => {
        let temp = checked ? [...new Set(values[props.name]), e] : values[props.name].filter(f => f !== e)
        setValues({
            ...values,
            [props.name]: [...temp]
        })
    }

    return (
        <label>
            <Row>
                <CheckBox
                    standalone
                    checked={values[props.name].find(e => e === props.value) || false}
                    onChange={(e) => handleChange(e.target.checked, props.value)}
                    disabled={props.disabled || submitting || !editing}
                    {...props}
                />
            </Row>
        </label>
    );
}

const ListItems = ({ name, type = 'radio', values, ...props }) => {
    return (
        <Wrapper>
            <MinContent>
                {props.heading}
            </MinContent>
            <Col>
                {values.map((e, i) =>
                    type === 'radio' ?
                        <RadioItem
                            key={generateId()}
                            name={name}
                            type={type}
                            value={e}
                            label={props.labels[i]}
                            {...props}
                        /> :
                        <CheckBoxItem
                            key={generateId()}
                            name={name}
                            type={type}
                            value={e}
                            label={props.labels[i]}
                            {...props}
                        />
                )}
            </Col>
        </Wrapper>
    );
}

export default ListItems;